//zh.js
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const zh = {
    m: {
        // ===== 导航 / 头部 =====
        "home": "首页",
        "contactUs": "联系我们",
        "more": "更多",
        "heroTitleRow1": "聚势厚土",
        "heroEyebrow": "齐鲁厚土 · 运河商贸 · 食品科技",
        "heroTitleRow2": "贵守食安",
        "heroFallbackSubtitle": "济宁聚合贵食品科技有限公司，立足孔孟之乡鲁地沃土，以科技赋能农副产业，构筑从产地到餐桌的食品产业新生态。",
        "learnBrand": "走进聚合贵",
        "viewProducts": "产品中心",
        "heroQrcodeAlt": "二维码",
        "heroQrcodeCaption": "扫码下载惠根APP",

        // ===== 页脚 =====
        "aboutUs": "关于我们",
        "news": "新闻动态",
        "noNews": "暂无新闻",
        "productCenter": "产品中心",
        "noProduct": "暂无产品",
        "copyright": "版权所有",
        "techSupport": "技术支持：济宁聚合贵食品科技有限公司软件研发部",
        "backToTop": "回到顶部",
        "companyProfile": "企业简介",
        "companyCulture": "企业文化",
        // 页脚「关于我们」下两个栏目的入口名（对应后台 type=page 栏目，与上面 qualification/contactUs 不是同一处文案，勿混用）
        "huigenApp": "惠根APP",
        "huiguiMall": "聚合贵小程序",
        "articleNotFound": "未找到对应内容",
        "defaultCompanyName": "济宁聚合贵食品科技有限公司",
        "defaultCompanyDesc": "济宁聚合贵食品科技有限公司，专注食品科技研发与生产，致力于为消费者提供健康、安全、美味的食品。",
        "defaultEmail": "18254785028@163.com",
        "defaultWorkTime": "周一至周五 9:00-18:00",

        // ===== 联系我们 =====
        "address": "地址",
        "companyAddress": "公司地址",
        "phone": "电话",
        "hotline": "联系电话",
        "email": "电子邮箱",
        "workTime": "工作时间",
        "defaultAddress": "山东省济宁市任城区",
        "defaultPhone": "18254785029",

        // ===== 首页 =====
        "featuredProducts": "精选产品",
        "projectBroadcast": "项目播报",
        "featured": "重点推荐",
        "viewMoreNews": "查看更多新闻",
        "viewMoreProducts": "查看更多产品",
        "noMore": "暂无更多",

        // ===== 列表页 =====
        "listTitle": "列表",
        "all": "全部",
        "readMore": "阅读全文",
        "viewDetails": "查看详情",
        "viewLarge": "查看大图",
        "loading": "加载中...",
        "noContent": "暂无相关内容",
        "prevPage": "上一页",
        "nextPage": "下一页",
        "pageInfo": "共 {total} 条记录，第 {current} / {pages} 页",

        // ===== 详情页 =====
        "detail": "详情",
        "views": "阅读",
        "prev": "上一篇",
        "next": "下一篇",
        "backToList": "返回列表",
        "backHome": "返回首页",

        // ===== 以下为历史遗留键，保留以免误删引用 =====
        "price": "产品中心",
        "Links": "友情链接",
        "Telephone": "电话",
        "mailbox": "邮箱",
        "Backtotop": "返回顶部",
        "CompanyProfile": "公司简介",
        "SalesDepartmentUKbranch": "销售部英国分公司",
        "technicalservice": "技术服务",
        "Latestbroadcast": "最新播报",
        "Companyqualification": "公司资质",
        "Orbitballvalve": "ORBIT轨道球阀",
        "Intelligence&Creation": "智能 & 创造",
        "Qualificationcertification": "资质认证",
        "Safeoperation": "安全作业",
        "Integratedsales": "整合销售",
        "Pastperformance": "以往业绩",
        "Professionalintegrityoftechnicalservices": "技术服务专业诚信",
        "Viewdetails": "查看详情",
        "homebar": "首页",
        "text": "正文",
        "list": "列表",
        "Previous": "上一条",
        "Next": "下一条",
        "previouspage": "上一页",
        "nextpage": "下一页",
        "nothing": "无",
        "Norelevantcontent": "暂无相关内容",
        "Tianjinpublicnetworksecurity": "津公网安备"
    },
    ...zhLocale
}

export default zh
